import React from "react";

const desktopImages = [
  "/images/gallery1.jpg",
  "/images/gallery2.jpg",
  "/images/gallery3.jpg",
  "/images/gallery4.jpg",
  "/images/gallery5.jpg",
  "/images/gallery6.jpg",
  "/images/gallery7.jpg",
  "/images/gallery8.jpg",
];

// Row 1: scrolls left
const row1 = [
  "/images/gallery1.jpg",
  "/images/gallery2.jpg",
  "/images/gallery3.jpg",
  "/images/gallery4.jpg",
];

// Row 2: scrolls right, staggered offset
const row2 = [
  "/images/gallery5.jpg",
  "/images/gallery6.jpg",
  "/images/gallery7.jpg",
  "/images/gallery8.jpg",
];

const GallerySection = () => {
  return (
    <>
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

        /* ===== SECTION ===== */
        .gallery-section {
          background-color: #f1f5f9;
          padding: 70px 0 60px;
          font-family: "Poppins", sans-serif;
          overflow: hidden;
          width: 100%;
        }

        /* ===== INNER WRAPPER ===== */
        .gallery-inner {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 48px;
          box-sizing: border-box;
        }

        /* ===== TITLE ===== */
        .gallery-title {
          text-align: center;
          font-size: 40px;
          font-weight: 700;
          margin: 0 0 52px;
          letter-spacing: -0.5px;
          background: linear-gradient(135deg, #1a1a2e 0%, #6a5af9 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* ===== DESKTOP GRID ===== */
        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 24px;
        }

        .gallery-card {
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1);
          transition: transform 0.4s ease, box-shadow 0.4s ease;
          cursor: pointer;
          background: #e2e8f0;
          position: relative;
        }

        .gallery-card::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, transparent, rgba(99, 102, 241, 0.2));
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .gallery-card img {
          width: 100%;
          height: 270px;
          object-fit: cover;
          display: block;
          transition: transform 0.45s ease;
          loading: lazy;
        }

        .gallery-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 22px 50px rgba(0, 0, 0, 0.18);
        }
        .gallery-card:hover::after {
          opacity: 1;
        }
        .gallery-card:hover img {
          transform: scale(1.07);
        }

        /* ===== MOBILE CAROUSEL ===== */
        .mobile-gallery {
          display: none;
        }

        /* ===== CTA BUTTONS ===== */
        .gallery-cta {
          margin-top: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 32px; /* Extra space between buttons for desktop professional look */
          flex-wrap: wrap;
        }
        .btn-link {
          text-decoration: none;
        }

        .gallery-btn {
          min-width: 160px;
          padding: 14px 36px;
          border-radius: 12px;
          border: none;
          font-family: "Poppins", sans-serif;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
          text-decoration: none;
        }

        /* 🟣 Primary Button : Book Now */
        .gallery-btn.primary {
          background: linear-gradient(135deg, #6366f1, #8b5cf6);
          color: white;
          box-shadow: 0 8px 24px rgba(99, 102, 241, 0.35);
        }
        .gallery-btn.primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(99, 102, 241, 0.45);
        }
        .gallery-btn.primary:active {
          transform: translateY(0px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
        }

        /* ⚪ Secondary Button : Call Now */
        .gallery-btn.secondary {
          background: #ffffff;
          color: #6366f1;
          border: 2px solid #c7d2fe;
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);
        }
        .gallery-btn.secondary:hover {
          border-color: #6366f1;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(99, 102, 241, 0.2);
        }
        .gallery-btn.secondary:active {
          transform: translateY(0px);
        }

        /* ===== TABLET ===== */
        @media (max-width: 1024px) {
          .gallery-inner {
            padding: 0 32px;
          }
          .gallery-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .gallery-card img {
            height: 240px;
          }
          .gallery-title {
            font-size: 32px;
          }
        }

        /* ===== MOBILE — 600px and below ===== */
        @media (max-width: 600px) {
          .gallery-section {
            padding: 52px 0 48px;
          }

          .gallery-inner {
            padding: 0;
          }

          .gallery-title {
            font-size: 26px;
            margin-bottom: 36px;
            padding: 0 16px;
          }

          /* Hide desktop grid */
          .gallery-grid {
            display: none;
          }

          /* Show mobile carousel */
          .mobile-gallery {
            display: block;
            overflow: hidden;
            width: 100%;
          }

          /* Each row */
          .carousel-row {
            overflow: hidden;
            width: 100%;
            margin-bottom: 14px;
          }

          .carousel-row:last-child {
            margin-bottom: 0;
          }

          /* Track — flex of tripled images for seamless loop */
          .carousel-track {
            display: flex;
            gap: 14px;
            width: max-content;
            will-change: transform;
          }

          /* Card */
          .m-gallery-card {
            width: 200px;
            flex-shrink: 0;
            border-radius: 14px;
            overflow: hidden;
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
            background: #e2e8f0;
          }

          .m-gallery-card img {
            width: 100%;
            height: 160px;
            object-fit: cover;
            display: block;
          }

          /* Smooth slower scroll animation */
          .row-left .carousel-track {
            animation: scrollLeft 22s linear infinite;
          }

          .row-right .carousel-track {
            animation: scrollRight 22s linear infinite;
          }

          @keyframes scrollLeft {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          @keyframes scrollRight {
            0%   { transform: translateX(-50%); }
            100% { transform: translateX(0); }
          }

          /* Pause on touch / hover */
          .carousel-row:hover .carousel-track,
          .carousel-row:active .carousel-track {
            animation-play-state: paused;
          }

          /* 📱 Mobile Buttons: Always side by side same line */
          .gallery-cta {
            margin-top: 40px;
            padding: 0 16px;
            flex-direction: row;
            gap: 16px; /* Proper space between buttons on mobile */
          }
          .gallery-btn {
            min-width: 145px;
            padding: 12px 20px;
            font-size: 14px;
          }
        }

        /* ===== EXTRA SMALL MOBILE ===== */
        @media (max-width: 380px) {
          .m-gallery-card {
            width: 170px;
          }
          .m-gallery-card img {
            height: 138px;
          }
          .carousel-track {
            gap: 12px;
          }
          .gallery-title {
            font-size: 22px;
          }
          .gallery-btn {
            min-width: 130px;
            font-size: 13px;
          }
        }
      `}</style>

      <section className="gallery-section">
        <div className="gallery-inner">

          <h2 className="gallery-title">Our Gallery</h2>

          {/* ── Desktop Grid ── */}
          <div className="gallery-grid">
            {desktopImages.map((img, index) => (
              <div className="gallery-card" key={index}>
                <img
                  src={img}
                  alt={`HexaPlay Gallery ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>

          {/* ── Mobile 2-Row Auto Reverse Scroll Carousel ── */}
          <div className="mobile-gallery">

            {/* Row 1 — scrolls LEFT */}
            <div className="carousel-row row-left">
              <div className="carousel-track">
                {[...row1, ...row1, ...row1].map((img, i) => (
                  <div className="m-gallery-card" key={`r1-${i}`}>
                    <img src={img} alt={`Gallery slide ${i + 1}`} loading="lazy" decoding="async" />
                  </div>
                ))}
              </div>
            </div>

            {/* Row 2 — scrolls RIGHT, staggered offset */}
            <div className="carousel-row row-right">
              <div className="carousel-track">
                {[...row2, ...row2, ...row2].map((img, i) => (
                  <div className="m-gallery-card" key={`r2-${i}`}>
                    <img src={img} alt={`Gallery slide ${i + 1}`} loading="lazy" decoding="async" />
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* ── CTA Buttons ── */}
          <div className="gallery-cta">
            <a href="/RoomCard" className="btn-link">
              <button className="gallery-btn primary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                Book Now
              </button>
            </a>

            <a href="tel:+919087775659" className="btn-link">
              <button className="gallery-btn secondary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.13 12.6a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.04 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                Call Now
              </button>
            </a>
          </div>

        </div>
      </section>
    </>
  );
};

export default GallerySection;